<app-header [forceLightBackground]="true"></app-header>
<div class="provider-access-requests">
  <div class="provider-access-requests--layout">
    <app-provider-sidebar class="provider-access-requests--sidebar"></app-provider-sidebar>
    <div class="provider-access-requests--content">
      <app-page-header
        [titleOverride]="pageTitle"
        [descriptionOverride]="pageDescription"
      ></app-page-header>
      <div class="access-requests-container">
        <div *ngIf="activeTab === 'assetRequest'">
          <app-asset-request
            [showPurposeColumn]="false"
            [showRequestTypeColumn]="true"
            [showRequestDateColumn]="true"
            [showCreatedAtColumn]="false"
            [showOrganisationColumn]="false"
            [showActionColumn]="true"
            [enableRequestStatusTabs]="true"
            [serverSideSorting]="true"
            [showExportButton]="true"
            conversationRoute="/provider/access-requests"
            (reloadData)="loadProviderAssetRequests()"
          ></app-asset-request>
        </div>

        <div *ngIf="activeTab === 'policies'">
          <app-created-policies
            policyPortal="provider"
            policyListType="created"
          ></app-created-policies>
        </div>
      </div>
    </div>
  </div>
</div>
